import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { Loader, NotFound } from 'components';
import { Layout } from 'components/Layout';
import { useBranchContext } from 'context/BranchesContext';
import {
  AddOns,
  Calendar,
  ConfirmedBooking,
  CustomerInformationForm,
  Home,
  Listing,
  Location,
  PaymentOption,
  PaymentQRCode,
  Search,
  TermsAndCondition,
} from 'pages';
import { DocumentUpload } from 'pages/DocumentUpload/DocumentUpload';
import { TimeSelectorPage } from 'pages/TimeSelectorPage/TimeSelectorPage';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/main.scss';
import { theme } from '../theme/theme';
const App: React.FC = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const locationCode = queryParams.get('locationCode') || 'da3';
  const code = queryParams.get('code');
  const source = queryParams.get('source');
  const { kioskLocation, isLoading, error } = useBranchContext();

  if (isLoading) return <Loader />;
  console.log('Fetching Branch Error.', error);
  if (error) toast.error('something went wrong');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Layout locationCode={kioskLocation?.Code}>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
            draggable
            theme="colored"
          />

          <Routes>
            <Route
              path={`/`}
              element={
                <Home locationCode={locationCode} code={code} source={source} />
              }
            />
            <Route path={`/search/:rental-type`} element={<Search />} />
            <Route
              path={`/location/:locationTypeParams`}
              element={<Location />}
            />
            <Route path="/date/:dateTypeParams" element={<Calendar />} />
            <Route
              path="/time/:timeTypeParams"
              element={<TimeSelectorPage />}
            />
            <Route path="/listing" element={<Listing />} />
            <Route path="/vehicle-addons" element={<AddOns />} />
            <Route
              path="/customer-information/:bookingDetailId"
              element={<CustomerInformationForm />}
            />
            <Route
              path="/payment-option/:bookingDetailIds"
              element={<PaymentOption />}
            />
            <Route path="/pay-amount/:bookingId" element={<PaymentQRCode />} />
            <Route
              path="/confirmed-booking/:bookingId/:status"
              element={<ConfirmedBooking />}
            />
            <Route path="/terms-condition" element={<TermsAndCondition />} />
            <Route path="/document-upload/:id" element={<DocumentUpload />} />
            <Route path="*" element={<NotFound />} />
            {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
          </Routes>
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
